module.exports = __webpack_public_path__ + "img/for-pc-preview.00895f50.png";